import React from "react";
import { useNavigate } from "react-router";
import {
  AppstoreAddOutlined,
  BankOutlined,
  CreditCardOutlined, DeleteRowOutlined, DesktopOutlined,
  ExceptionOutlined,
  GiftOutlined,
  LockOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ShoppingCartOutlined
} from "@ant-design/icons";
import { Badge, Menu } from "antd";
import {
  BrowserSvg,
  ColumnSvg,
  DiscountSvg,
  MapSvg,
  NewsSvg,
  OrderSvg,
  ProductSvg,
  TruckSvg,
  UsersSvg} from "src/components/Svg";
import { usePermission } from "src/hooks";
import styled from "styled-components";

function filterByPermission(items, hasPermission) {
  return items
    .filter((item) => {
      if (item.permission && !hasPermission(item.permission)) {
        return false
      }
      return true
    })
    .map((item) => {
      if (item.children) {
        const filtered = filterByPermission(item.children, hasPermission)
        if (filtered.length === 0) return null
        return { ...item, children: filtered }
      }
      return item
    })
    .filter(Boolean)
}

export function NavMenu() {
  let currentSvgProps = {
    stroke: "currentColor",
    strokeWidth: 1.5,
    size: 20,
  };

  const navigate = useNavigate();
  const { hasPermission } = usePermission();

  const menuItems = [
    {
      icon: UsersSvg(currentSvgProps),
      onClick: () => navigate("/dashboard/clients"),
      key: "/dashboard/clients",
      title: "Клиенты",
      label: "Клиенты",
      permission: "clients.view",
    },
    {
      icon: <LockOutlined style={{ fontSize: "16px" }} />,
      onClick: () => navigate("/dashboard/auth-requests"),
      key: "/dashboard/auth-requests",
      title: "Авторизации",
      label: "Авторизации",
      permission: "auth-requests.view",
    },
    {
      icon:  <MessageOutlined style={{ fontSize: "16px"}}/>,
      onClick: () => navigate("/dashboard/push"),
      key: "/dashboard/push",
      title: "Пуши",
      label: "Пуши",
      permission: "push.view",
    },

    {
      icon: ProductSvg(currentSvgProps),
      key: "sub_0",
      label: "Продукты",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/product-categories"),
          key: "/dashboard/product-categories",
          title: "Категории",
          label: "Категории",
          permission: "product-categories.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/products-groups"),
          key: "/dashboard/products-groups",
          title: "Группы категорий",
          label: "Группы категорий",
          permission: "products-groups.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/products"),
          key: "/dashboard/products",
          title: "Товары",
          label: "Товары",
          permission: "products.view",
        },
        {
          icon: MapSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/points-product"),
          key: "/dashboard/points-product",
          title: "Доступность",
          label: "Доступность",
          permission: "point-products.view",
        },
        {
          icon: TruckSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/product-constructor"),
          key: "/dashboard/product-constructor",
          title: "Добавки",
          label: "Добавки",
          permission: "product-constructor.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/certificates"),
          key: "/dashboard/certificates",
          title: "Сертификаты",
          label: "Сертификаты",
          permission: "certificates.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/products-video"),
          key: "/dashboard/products-video",
          title: "Видео карточки",
          label: "Видео карточки",
          permission: "product-video.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/virtual-product-categories"),
          key: "/dashboard/virtual-product-categories",
          title: "Вирт. категории",
          label: "Вирт. категории",
          permission: "virtual-product-categories.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/product-sets"),
          key: "/dashboard/product-sets",
          title: "Наборы",
          label: "Наборы",
          permission: "product-sets.view",
        },
      ],
    },
    {
      icon: MapSvg(currentSvgProps),
      key: "sub_1",
      label: "Точки",
      title: "Точки",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/points"),
          key: "/dashboard/points",
          title: "Точки",
          label: "Точки",
          permission: "points.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/point-categories"),
          key: "/dashboard/point-categories",
          title: "Типы точек",
          label: "Типы точек",
          permission: "points.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/delivery-areas"),
          key: "/dashboard/delivery-areas",
          title: "Зоны доставки",
          label: "Зоны доставки",
          permission: "delivery-areas.view",
        }
      ]

    },
    {
      icon: <CreditCardOutlined />,
      onClick: () => navigate("/dashboard/payment-accounts"),
      key: "/dashboard/payment-accounts",
      title: "Платежные акк.",
      label: "Платежные акк.",
      permission: "payment-accounts.view",
    },
    {
      icon: OrderSvg(currentSvgProps),
      key: "sub_2",
      label: "Заказы",
      title: "Заказы",
      children: [
        {
          icon: OrderSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/orders"),
          key: "/dashboard/orders",
          title: "Заказы",
          label: "Заказы",
          permission: "orders.view",
        },
        {
          icon: <DeleteRowOutlined />,
          onClick: () => navigate("/dashboard/stuck-orders"),
          key: "/dashboard/stuck-orders",
          title: "Застрявшие заказы",
          label: "Застрявшие заказы",
          permission: "stuck-orders.view",
        },
        {
          icon: <AppstoreAddOutlined />,
          onClick: () => navigate("/dashboard/manual-order"),
          title: "Ручные заказы",
          label: "Ручные заказы",
          permission: "manual-orders.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/receipts"),
          key: "/dashboard/receipts",
          title: "Чеки",
          label: "Чеки",
          permission: "receipts.view",
        }
      ]
    },
    {
      icon: <BankOutlined />,
      onClick: () => navigate("/dashboard/order-hold-payment"),
      key: "/dashboard/order-hold-payment",
      title: "Оплаты в холде",
      label: "Оплаты в холде",
      permission: "order-hold-payment.view",
    },
    {
      icon: <SettingOutlined />,
      key: "sub_3",
      label: "Настройки",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/delivery-setting"),
          key: "/dashboard/delivery-setting",
          title: "Настройки доставки",
          label: "Настройки доставки",
          permission: "delivery-setting.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/intervals-custom-settings"),
          key: "/dashboard/intervals-custom-settings",
          title: "Настройки интервалов",
          label: "Настройки интервалов",
          permission: "interval-custom-settings.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/system-settings"),
          key: "/dashboard/system-settings",
          title: "Системные настройки",
          label: "Системные настройки",
          permission: "system-settings.view",
        },
      ],
    },
    {
      icon: DiscountSvg(currentSvgProps),
      key: "sub_4",
      label: "Промокоды",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/promo-codes"),
          key: "/dashboard/promo-codes",
          title: "Промокоды",
          label: "Промокоды",
          permission: "promo-codes.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/partner-discounts"),
          key: "/dashboard/partner-discounts",
          title: "Партнерские скидки",
          label: "Партнерские скидки",
          permission: "partner-discounts.view",
        },
      ],
    },
    {
      icon: BrowserSvg(currentSvgProps),
      key: "sub_5",
      label: "Главная",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/live-love-work"),
          key: "/dashboard/live-love-work",
          title: "Больше чем булочки",
          label: "Больше чем булочки",
          permission: "live-love-work.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/stories-v2"),
          key: "/dashboard/stories-v2",
          title: "Истории",
          label: "Истории",
          permission: "stories-v2.view",
        },
      ],
    },
    {
      icon: NewsSvg(currentSvgProps),
      key: "sub_6",
      title: "Акции и новости",
      label: "Акции и новости",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/promotion-categories"),
          key: "/dashboard/promotion-categories",
          title: "Категории акций",
          label: "Категории акций",
          permission: "promotion-categories.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/promotions"),
          key: "/dashboard/promotions",
          title: "Акции",
          label: "Акции",
          permission: "promotions.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/article-categories"),
          key: "/dashboard/article-categories",
          title: "Категории новостей",
          label: "Категории новостей",
          permission: "article-categories.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/articles"),
          key: "/dashboard/articles",
          title: "Новости",
          label: "Новости",
          permission: "articles.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/event-categories"),
          key: "/dashboard/event-categories",
          title: "Категории мероприятий",
          label: "Категории мероприятий",
          permission: "event-categories.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/events"),
          key: "/dashboard/events",
          title: "Мероприятия",
          label: "Мероприятия",
          permission: "events.view",
        },
      ],
    },
    {
      icon: <ExceptionOutlined />,
      onClick: () => navigate("/dashboard/onboarding"),
      key: "/dashboard/onboarding",
      label: "Онбординг",
      permission: "onboarding.view",
    },
    {
      icon: <GiftOutlined />,
      key: "sub_7",
      label: "Система лояльности",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/achievements"),
          key: "/dashboard/achievements",
          title: "Квесты",
          label: "Квесты",
          permission: "achievements.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/rewards"),
          key: "/dashboard/rewards",
          title: "Награды",
          label: "Награды",
          permission: "rewards.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/user-status-groups"),
          key: "/dashboard/user-status-groups",
          title: "Группы статусов",
          label: "Группы статусов",
          permission: "user-status-groups.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/user-statuses"),
          key: "/dashboard/user-statuses",
          title: "Статусы",
          label: "Статусы",
          permission: "user-statuses.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/bonus-distributions"),
          key: "/dashboard/bonus-distributions",
          title: "Рассылка баллов",
          label: "Рассылка баллов",
          permission: "bonus-distributions.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/bonus-points"),
          key: "/dashboard/bonus-points",
          title: "Баллы: наши операции",
          label: "Баллы: наши операции",
          permission: "bonus-points.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/bonus-points-tillypad"),
          key: "/dashboard/bonus-points-tillypad",
          title: "Баллы: история Tillypad",
          label: "Баллы: история Tillypad",
          permission: "bonus-points.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/bonus-points-debts"),
          key: "/dashboard/bonus-points-debts",
          title: "Баллы: минусовые балансы",
          label: "Баллы: минусовые балансы",
          permission: "bonus-points.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/segments"),
          key: "/dashboard/segments",
          title: "Сегменты",
          label: "Сегменты",
          permission: "segments.view",
        }
      ],
    },
    {
      icon: <QuestionCircleOutlined />,
      onClick: () => navigate("/dashboard/faq"),
      key: "/dashboard/faq",
      label: "FAQ",
      permission: "faq.view",
    },
    {
      icon: <MessageOutlined />,
      onClick: () => navigate("/dashboard/support-channels"),
      key: "/dashboard/support-channels",
      label: "Каналы поддержки",
      permission: "support-channels.view",
    },
    {
      icon: <ShoppingCartOutlined />,
      key: "sub_carts",
      label: "Корзины",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/abandoned-carts"),
          key: "/dashboard/abandoned-carts",
          title: "Брошенные корзины",
          label: "Брошенные корзины",
          permission: "abandoned-carts.view",
        }
      ]
    },
    {
      icon: <DesktopOutlined />,
      key: "sub_8",
      label: "Данные сайта",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/banners"),
          key: "/dashboard/banners",
          title: "Баннер сайта",
          label: "Баннер сайта",
          permission: "banners.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/additional-info"),
          key: "/dashboard/additional-info",
          title: "Доп. информация",
          label: "Доп. информация",
          permission: "additional-info.view",
        }
      ]
    },
    {
      icon: <LockOutlined />,
      key: "sub_9",
      label: "Управление доступом",
      children: [
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/permissions"),
          key: "/dashboard/permissions",
          title: "Разрешения",
          label: "Разрешения",
          permission: "permissions.view",
        },
        {
          icon: ColumnSvg(currentSvgProps),
          onClick: () => navigate("/dashboard/roles"),
          key: "/dashboard/roles",
          title: "Роли",
          label: "Роли",
          permission: "roles.view",
        },
      ]
    }
  ];

  const filteredItems = filterByPermission(menuItems, hasPermission);

  return <StyledMenu mode="inline" inlineIndent={0} items={filteredItems} />;
}
const StyledBadge = styled(Badge)`
  &&& {
    font-weight: 700;
    margin-left: 5px;
    font-size: 10px;
    line-height: 17px;
    height: 17px;
    overflow-x: clip !important;
    margin-top: -3px;
  }
`;

const StyledMenu = styled(Menu)`
  &&& {
    border-right: 0;
    display: flex;
    flex-direction: column;
    margin: 4px 0;
  }
`;
